import { render, staticRenderFns } from "./HolidayAlert.vue?vue&type=template&id=c62bdb4a&scoped=true&"
import script from "./HolidayAlert.vue?vue&type=script&lang=js&"
export * from "./HolidayAlert.vue?vue&type=script&lang=js&"
import style0 from "./HolidayAlert.vue?vue&type=style&index=0&id=c62bdb4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62bdb4a",
  null
  
)

export default component.exports